<template>
  <div class="companyShows">
    <div>

      <div>
        <table class="processshow-table">
          <tbody>
            <tr style="box-sizing: border-box;"
                class="firstRow">
              <th width="5%">
                <span>项目</span>
              </th>
              <th width="30%">
                <span>内容</span>
              </th>
              <th width="25%">
                <span>工艺能力</span>
              </th>
              <th width="40%">
                <span>备注</span>
              </th>
            </tr>
            <tr>
              <td>
                <p>1</p>
              </td>
              <td>层数</td>
              <td>1-8层</td>
              <td>是指PCB中的电气层数（敷铜层数），目前飞天只接受1~8层通孔板（不接受盲埋孔板）</td>
            </tr>
            <tr>
              <td rowspan="2">
                <p>2</p>
              </td>
              <td rowspan="2">板材</td>
              <td>FR-4</td>
              <td> 国纪，建涛，生益</td>
            </tr>
            <tr>
              <td>CEM-1</td>
              <td>

              </td>
            </tr>
            <tr>
              <td rowspan="2">
                <p>3</p>
              </td>
              <td rowspan="2">油墨</td>
              <td>容大</td>
              <td>
                阻焊油
              </td>
            </tr>
            <tr>
              <td>太阳</td>
              <td>
                文字油
              </td>
            </tr>

            <tr>
              <td>
                <p>4</p>
              </td>
              <td>生产板尺寸（最大）</td>
              <td>600×520mm</td>
              <td>
                <p>单双面：单片和拼板600×520mm</p>
                <p>多层板：590×510mm</p>
              </td>
            </tr>
            <tr>
              <td>
                <p>5</p>
              </td>
              <td>生产板尺寸（最小）</td>
              <td>
                80*80mm
              </td>
              <td>
                <p>单板最小生产尺寸＞80*80mm</p>
              </td>
            </tr>
            <tr>
              <td>
                <p>6</p>
              </td>
              <td>板厚度（最大）</td>
              <td>3.2mm</td>
              <td rowspan="2">板厚:0.4/0.6/0.8/1.0/1.2/1.6/2.0/2.4/3.2mm</td>
            </tr>
            <tr>
              <td>
                <p>7</p>
              </td>
              <td>板厚度（最小）</td>
              <td>0.4mm</td>
            </tr>
            <tr>
              <td>
                <p>8</p>
              </td>
              <td>芯板厚度（最小）</td>
              <td>0.20mm</td>
              <td>含铜厚度</td>
            </tr>
            <tr>
              <td>
                <p>9</p>
              </td>
              <td>成品厚度公差（板厚≥0.8mm）</td>
              <td>±10%</td>
              <td>比如板厚T=1.6mm，实物板厚为1.44mm（T－1.6×10%）~1.76mm（T＋1.6×10%）</td>
            </tr>
            <tr>
              <td>
                <p>10</p>
              </td>
              <td>
                  {{`成品厚度公差（0.4mm≤板厚 ≤ 0.8mm）`}}
              </td>
              <td>±0.10mm</td>
              <td>比如板厚T=0.6mm，实物板厚为0.5mm（T-0.1）~0.7mm（T+0.1）</td>
            </tr>
            <tr>
              <td>
                <p>11</p>
              </td>
              <td>板曲(最小)</td>
              <td>0.75%</td>
              <td>对角线长度*0.75%</td>
            </tr>
            <tr>
              <td>
                <p>12</p>
              </td>
              <td>钻孔孔径（最大）</td>
              <td>Φ6.0mm</td>
              <td>于6.0mm可锣孔</td>
            </tr>
            <tr>
              <td>
                <p>13</p>
              </td>
              <td>钻孔孔径（最小）</td>
              <td>Φ0.25mm</td>
              <td>0.25mm是钻孔的最小孔径</td>
            </tr>
            <tr>
              <td>
                <p>14</p>
              </td>
              <td>外层底铜厚度(最小)</td>
              <td>单面板及双面：Hoz、多层Hoz</td>
              <td>指成品电路板外层线路铜箔的最小厚度，飞天最小做到：单面板及双面Hoz、多层Hoz</td>
            </tr>
            <tr>
              <td>
                <p>15</p>
              </td>
              <td>外层底铜厚度(最大)</td>
              <td>3oz</td>
              <td>指成品电路板外层线路铜箔的最大厚度，飞天最大做到3oz</td>
            </tr>
            <tr>
              <td>
                <p>16</p>
              </td>
              <td>内层底铜厚度(最小)</td>
              <td>Hoz</td>
              <td>指成品电路板内层线路铜箔的最小厚度，飞天最小做到Hoz</td>
            </tr>
            <tr>
              <td>
                <p>17</p>
              </td>
              <td>内层底铜厚度(最大)</td>
              <td>3oz</td>
              <td>指成品电路板外层线路铜箔的最大厚度，飞天最大做到3oz</td>
            </tr>
            <tr>
              <td>
                <p>18</p>
              </td>
              <td>绝缘层厚度(最小)</td>
              <td>0.10mm</td>
              <td>PP胶片压合后厚度0.10mm</td>
            </tr>
            <tr>
              <td>
                <p>19</p>
              </td>
              <td>孔电镀纵横比(最大)</td>
              <td>10:1</td>
              <td></td>
            </tr>
            <tr>
              <td>
                <p>20</p>
              </td>
              <td>孔径公差(PTH有铜孔)</td>
              <td>±0.075mm</td>
              <td>PTH有铜孔：钻孔的公差为±0.075mm，例如设计为0.6mm的孔，实物板的成品孔径在0.525mm-0.675mm是合格允许的</td>
            </tr>
            <tr>
              <td>
                <p>21</p>
              </td>
              <td>孔径公差(NPTH无铜孔)</td>
              <td>±0.05mm</td>
              <td>NPTH无铜孔：钻孔的公差为±0.05mm，例如设计为0.6mm的孔，实物板的成品孔径在0.55mm-0.65mm是合格允许的</td>
            </tr>
            <tr>
              <td>
                <p>22</p>
              </td>
              <td>孔位公差</td>
              <td>±0.05mm</td>
              <td></td>
            </tr>
            <tr>
              <td>
                <p>23</p>
              </td>
              <td>孔壁铜厚（通孔）</td>
              <td>常规平均值≥18um</td>
              <td>客户可另作指定</td>
            </tr>
            <tr>
              <td>
                <p>24</p>
              </td>
              <td>外层设计线宽/间距（最小）</td>
              <td>
                1/1oz: 4mil/5mil<br>
                2/2oz: 8mil/8mil<br>
                3/3oz: 12mil/12mil
              </td>
              <td>此参数为飞天默认</td>
            </tr>
            <tr>
              <td>
                <p>25</p>
              </td>
              <td>内层设计线宽/间距（最小）</td>
              <td>
                H/Hoz: 4mil/5mil<br>
                1/1oz: 4mil/5mil<br>
                2/2oz: 8mil/8mil<br>
                3/3oz: 12mil/12mil
              </td>
              <td>此参数为飞天默认</td>
            </tr>
            <tr>
              <td>
                <p>26</p>
              </td>
              <td>蚀刻公差</td>
              <td>±15%</td>
              <td>例如线宽 T=4mil，实际线宽为3.4mil（T－4mil×15%）~4.6mil（T＋4mil×15%）</td>
            </tr>
            <tr>
              <td>
                <p>27</p>
              </td>
              <td>外层图形对孔位精度（最小）</td>
              <td>±3mil</td>
              <td>线路图像对孔位精度，实物相差±3mil为合格</td>
            </tr>
            <tr>
              <td>
                <p>28</p>
              </td>
              <td>孔位对孔位精度(最小)</td>
              <td>±2mil</td>
              <td>线路图像孔位对实物孔位精度±2mil为合格</td>
            </tr>
            <tr>
              <td>
                <p>29</p>
              </td>
              <td>阻焊对位精度公差</td>
              <td>±3mil</td>
              <td>线路图像对防焊位置精度公差±3mil为合格</td>
            </tr>
            <tr>
              <td>
                <p>30</p>
              </td>
              <td>阻焊厚度（最小）</td>
              <td>≥8μm</td>
              <td>阻焊采用容大油墨≥8μm</td>
            </tr>
            <tr>
              <td>
                <p>31</p>
              </td>
              <td>阻焊桥宽（最小）</td>
              <td>
                绿油：4mil<br>
                黑/白色：5mil<br>
                其他杂色油：4mil

              </td>
              <td>
                若有阻焊桥要求，必须备注！阻焊桥价格会根据工艺要求上浮。若阻焊颜色为绿色焊盘间保留油墨宽度必须≥4mil （完成铜厚为1oz的线路焊盘间距需要有7mil），黑色、白色焊盘间保留油墨宽度必须≥5mil（完成铜厚为1oz的线路焊盘间距需要有7mil）， 其它杂色油焊盘间保留油墨宽度必须为≥4mil
              </td>
            </tr>
            <tr>
              <td>
                <p>32</p>
              </td>
              <td>阻焊塞孔孔径</td>
              <td>≤0.4mm</td>
              <td>飞天阻焊塞孔孔径规定≤0.4mm，板内孔＞0.4mm时默认盖油</td>
            </tr>
            <tr>
              <td>
                <p>33</p>
              </td>
              <td>沉镍沉金镍厚</td>
              <td>100-200uin（μ"）</td>
              <td>特殊需求可指定</td>
            </tr>
            <tr>
              <td>
                <p>34</p>
              </td>
              <td>沉镍沉金金厚</td>
              <td>1-2u"</td>
              <td>特殊需求可指定</td>
            </tr>
            <tr>
              <td>
                <p>35</p>
              </td>
              <td>锡厚（热风整平）</td>
              <td>1-40um</td>
              <td>常规3-5um</td>
            </tr>
            <tr>
              <td>
                <p>36</p>
              </td>
              <td>铣外形公差</td>
              <td>±5mil</td>
              <td></td>
            </tr>
            <tr>
              <td>
                <p>37</p>
              </td>
              <td>铣外形公差（孔到边）</td>
              <td>±4mil</td>
              <td></td>
            </tr>
            <tr>
              <td>
                <p>38</p>
              </td>
              <td>铣外形圆弧（内角）（最小）</td>
              <td>R≥0.5mm</td>
              <td></td>
            </tr>
            <tr>
              <td>
                <p>39</p>
              </td>
              <td>铣沉头孔孔径</td>
              <td>依客户要求</td>
              <td>依客户要求</td>
            </tr>
            <tr>
              <td>
                <p>40</p>
              </td>
              <td>V-CUT剩余厚度公差（最小）</td>
              <td>±0.10mm</td>
              <td>V-CUT剩余厚度公差最小±0.10mm</td>
            </tr>
            <tr>
              <td>
                <p>41</p>
              </td>
              <td>V-CUT错位度（最小）</td>
              <td>0.10mm</td>
              <td>V-CUT错位度最小0.10mm</td>
            </tr>
            <tr>
              <td>
                <p>42</p>
              </td>
              <td>V-CUT板厚厚度（最小/最大）</td>
              <td>0.5mm/3.2mm</td>
              <td>目前支持V-CUT板厚0.5mm～3.2mm（≤0.4mm建议邮票孔，如指定V-CUT默认不满足±0.10mm公差）</td>
            </tr>
            <tr>
              <td>
                <p>43</p>
              </td>
              <td>阻抗公差（最小）</td>
              <td>±10%</td>
              <td>例如选择的阻抗值为T=50Ω，实际阻抗为45Ω（T－50Ω×10%）~55Ω（T＋50Ω×10%）</td>
            </tr>
            <tr>
              <td>
                <p>44</p>
              </td>
              <td>孔距/孔到线制程范围</td>
              <td></td>
              <td>
                <p>VIA导通孔到孔0.3MM</p>
                <p>PTH元件孔到元件孔0.5MM</p>
                <p>VIA导通孔到线0.25MM</p>
                <p>PTH元件孔到线0.3MM</p>
              </td>
            </tr>
            
          </tbody>
        </table>
      </div>
    </div>
    <!-- <div>
      
      <div>
        <p>Product use and technical capability</p>
        <hr><i>产品用途和技术能力</i>
        <hr>
        <div class="flex">
          <div v-for="(i,index ) in img"
               :key="index">
            <img :src="i.url"
                 alt="">
          </div>
        </div>
      </div>
      <div>
        <p>The heart of the company</p>
        <hr><i>公司核心</i>
        <hr>
        <div class="flex">
          <div> <img style="width:50rem"
                 src="../../assets/imges/微信图片_202103120853199.png"
                 alt=""></div>
        </div>
      </div>
      <div style="margin-bottom:1rem">
        <p>Product use and technical capability</p>
        <hr><i>先进设备</i>
        <hr>
        <div class="flex">
          <div>
            <img style="width:50rem;margin-right:1rem"
                 src="../../assets/imges/微信图片_2021031208531938.png"
                 alt="">
            <img style="width:50rem"
                 src="../../assets/imges/微信图片_2021031208531937.png"
                 alt="">
          </div>
        </div>
      </div>
       <div style="margin-bottom:1rem">
        <p>Company Qualifications</p>
        <hr><i>公司资历</i>
        <hr>
        <div class="flex">
          <div>
            <img style="width:50rem;margin-right:1rem"
                 src="../../assets/imges/微信图片_202103120853197.png"
                 alt="">
            <img style="width:50rem"
                 src="../../assets/imges/微信图片_202103120853198.png"
                 alt="">
          </div>
        </div>
      </div>
    </div> -->
  </div>
</template>
<script>
export default {
  data() {
    return {}
  }
}
</script>
<style lang="scss" scoped>
   p {
          color: #000;
    margin-block-start: 1em;
    margin-block-end: 1em;
    margin-inline-start: 0px;
    margin-inline-end: 0px;
    font-size: 0.8rem;
   
}
.processshow-table {
 
    width: 60%;
    margin: 0 auto;
    border-collapse: collapse;
    font-size: 0.8rem;
     tr td {
    padding: 0.9rem 1.2rem;
    border: 0.1rem solid #e7e7e7;
    color: #333;
    font-size: 0.8rem;
    line-height: 1.3rem;
  
}
    
     tr th {
    border: 1px solid #767676;
    background-color: #767676;
    color: #fff;
    padding: 8px 20px;
    text-align: left;
}
}
.companyShows {
  div {
    div {
      text-align: center;
      margin-top: 0.5rem;
      .flex {
        justify-content: center;
        div :hover {
          border: 0.1rem solid #09f;
          border-radius: 0.2rem;
        }
        div {
          img {
            width: 40rem;
            margin-right: 1rem;
          }
        }
      }
      i {
        font-style: unset;
        font-size: 1.5rem;
        color: #09f;
        margin-top: 0.5rem;
        display: inline-block;
      }
      hr {
        width: 3rem;
        display: inline-block;
        margin-bottom: 0.5rem;
      }
     
    }
  }
}
</style>


// WEBPACK FOOTER //
// src/view/home/companyShows.vue